// Esta función crea el popup de logros que ya tenemos estilizado en App.css
export function showAchievement(text, icon = '🏆') {
  // Evitar crear múltiples popups si ya existe uno
  if (document.getElementById('achievement-popup')) return;

  const achievement = document.createElement('div');
  achievement.id = 'achievement-popup';
  achievement.className = 'achievement';
  
  const achievementIcon = document.createElement('span');
  achievementIcon.className = 'achievement-icon';
  achievementIcon.textContent = icon;

  const achievementText = document.createElement('span');
  achievementText.textContent = text;
  
  achievement.appendChild(achievementIcon);
  achievement.appendChild(achievementText);
  document.body.appendChild(achievement);

  // Forzar un reflow para que la animación funcione
  requestAnimationFrame(() => {
    achievement.classList.add('show');
  });

  // Ocultar y eliminar el popup después de 3 segundos
  setTimeout(() => {
    achievement.classList.remove('show');
    setTimeout(() => {
      achievement.remove();
    }, 500); // Esperar a que la animación de salida termine
  }, 3000);
}

// Esta función lanza el confeti
export function launchConfetti() {
  const colors = ['#667eea', '#764ba2', '#f093fb', '#4ade80', '#fbbf24', '#f87171'];
  const confettiCount = 100;

  for (let i = 0; i < confettiCount; i++) {
    setTimeout(() => {
      const confetti = document.createElement('div');
      confetti.style.cssText = `
        position: fixed;
        width: ${Math.random() * 10 + 5}px;
        height: ${Math.random() * 15 + 10}px;
        background: ${colors[Math.floor(Math.random() * colors.length)]};
        left: ${Math.random() * 100}%;
        top: -20px;
        border-radius: ${Math.random() > 0.5 ? '50%' : '0'};
        transform: rotate(${Math.random() * 360}deg);
        animation: fall ${Math.random() * 3 + 2}s linear forwards;
        z-index: 1001; /* Por encima del popup */
        pointer-events: none;
      `;
      document.body.appendChild(confetti);
      
      // Eliminar el confeti del DOM después de que caiga
      setTimeout(() => confetti.remove(), 5000);
    }, i * 20); // Lanzar en una pequeña cascada
  }

  // Asegurarnos de que la animación 'fall' esté definida.
  // La añadimos al head si no existe.
  if (!document.getElementById('confetti-animation-style')) {
    const style = document.createElement('style');
    style.id = 'confetti-animation-style';
    style.textContent = `
      @keyframes fall {
        to {
          transform: translateY(100vh) rotate(720deg);
          opacity: 0;
        }
      }
    `;
    document.head.appendChild(style);
  }
}
